import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../components/header_logged'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import DiariasLogged from '../../../components/auth/diarias'

function DiariasLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo de Diárias concedidas aos servidores do Município de Macuco" />
                <HeaderLogged />
                <Container>
                   <DiariasLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default DiariasLoggedScreen;